import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { ActionsListWidget, LoadingWidget } from '../../../../widgets';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEntNivelesAcademicosAction,
  deleteEntNivelesAcademicosAction,
  setActivoEntNivelesAcademicosAction,
} from '../EntNivelesAcademicosAction';
import { PARAMS_ENT_NIVELES_ACADEMICOS } from '../EntNivelesAcademicosReducer';

const ListadoEntNivelesAcademicos = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entNivelesAcademicosStore = Redux.useSelector(
    (state) => state.entNivelesAcademicos,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      const payload = {
        idEntidad: entidadesStore.activo.id,
        ...entNivelesAcademicosStore.params,
      };
      dispatch({ type: PARAMS_ENT_NIVELES_ACADEMICOS, payload });
      if (
        entNivelesAcademicosStore.all &&
        entNivelesAcademicosStore.all.length === 0
      ) {
        await allEntNivelesAcademicosAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const _handleEditClick = async (id) => {
  //   const data = entNivelesAcademicosStore.all.find((el) => el.id === id);
  //   await setActivoEntNivelesAcademicosAction(dispatch, data);
  //   setOpenModalForm(true);
  // };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteEntNivelesAcademicosAction(
      { dispatch, notify },
      entNivelesAcademicosStore.activo.id,
      entNivelesAcademicosStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nivelAcademico.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
            // onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.nombre}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.nivelAcademico.name,
      label: CONST.categoria.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.categoria ? (
            <Chip
              label={value.categoria}
              size="small"
              color="primary"
              sx={{ m: 0.5 }}
            />
          ) : (
            <Typography variant="body1" color="initial">
              --
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.nivelAcademico.name,
      label: CONST.abrev.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Typography>{value.abrev}</Typography>;
        },
      },
    },
    {
      name: CONST.nivelAcademico.name,
      label: 'Número',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Typography>{value.numero}</Typography>;
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onDelete={async () => {
                  const data = entNivelesAcademicosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoEntNivelesAcademicosAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  const data = entNivelesAcademicosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  window.open(data.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    daowload: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={entNivelesAcademicosStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={entNivelesAcademicosStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {entNivelesAcademicosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {entNivelesAcademicosStore.activo.nivelAcademico.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEntNivelesAcademicos;
